<template>
  <div class="menuBody">
    <ReportTree @ReportTree="getMsgFormSon"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row>
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                票据作废报表 <!--  收费报表管理--票据作废报表  -->
            <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;display:none" @click="Derive()">导出</el-button>
            </div>
            <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain  style="background: #38A38A;color:#fff;border-radius:9px;"  v-Jurisdiction="'expense:web:cr:billVoidList:getInvalidInvoiceList'" @click="Create()">生成报表</el-button>
            </div>
            </div>
              <div style="width:220px;float:left;margin-right:15px">
                   <el-date-picker
                      size="small"
                      style="width:220px;float:left;"
                      v-model="DateTime"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="BillDateTime()">
                    </el-date-picker>
              </div>
             <div style="width:150px;float:left;margin-right:15px">
                 <el-input placeholder="请输入票据编号" size="small"    v-model="Macode"></el-input>
              </div>
               <div style="width:150px;float:left;margin-right:15px">
                 <el-input placeholder="请输入票据号码" size="small"    v-model="Macodde"></el-input>
              </div>
              <div style="width:200px;float:left;margin-right:15px">
                  <el-select  clearable  v-model="ReceiptWayval" multiple
                    size="small"
                    collapse-tags
                    @change="receiptChange"
                    placeholder="请选择收款方式">
                    <el-option
                    v-for="item in receiptType"
                    :key="item.receiptTypevalue"
                    :label="item.receiptTypelabel"
                    :value="item.receiptTypevalue"
                    >
                    </el-option>
                </el-select>
            </div>
  <div style="width:170px;float:left;margin-right:15px">
                 <el-cascader
                  :show-all-levels="false"
                  v-model="amountval"
                  :options="osData"
                  :props="props"
                  size="small"
                  @change="ChangeOsData(amountval)"
                  collapse-tags
                  clearable
                ></el-cascader>
            </div>
<!-- 票据簿编号	票据号码	付款人	项目名称	房间名称	收费项目	摘要	金额	税额	收入	开票日期	开票人	收款日期	收款人	收款方式	作废日期	作废人	作废原因	详情 -->
              <el-table tooltip-effect="light" show-summary
    :summary-method="getSummaries"     border  v-loading="loading"  :data="tableData"   style="overflow-y: scroll;float:right;margin-top:20px" row-key="id"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column label="序号" type="index" width="60"></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceDm" label="票据簿编号" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceHm" label="票据号码" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payer" label="付款人" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="projectName" label="项目名称" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjSkpzDh" label="房间名称" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="inf.invoiceObject" label="收费项目" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="inf.abstractInfo" label="摘要" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="inf.money" label="金额" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="inf.tax" label="税额" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="SRu" label="收入" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="makeInvoiceDate" label="开票日期" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payee" label="开票人" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjSkrqDate" label="收款日期" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payee" label="收款人" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payMethod" label="收款方式" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="scrapDateS" label="作废日期" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="scrapMan" label="作废人" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="scrapDes" label="作废原因" ></el-table-column>
    <!-- <el-table-column show-overflow-tooltip prop="zjSkrq" label="详情" ></el-table-column> -->
  </el-table>
      <!-- <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination> -->
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import ReportTree from "./ReportTree.vue";

export default {
  name: "BillInvalid",
  components: {ReportTree},
  data() {
    return {
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        diaLogVisible: false,
        AllData:[],
        tableData:[],

        projectIds:[],
        DateTime:[],
        Macode:"",
        Macodde:"",
        receiptTypevalue:"",
        receiptType:[],
        ReceiptWayval:"",
        amountval:"",
        props: { multiple: true },
        osData:[],
    }
  },
  methods: {
        getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
        }
        // index >= 3 || index <= 11 是你需要计算的列
        // 当然也可以指定一个或者多个列
        // index === 2 || index === 3 这样值求和第二个与第三个列
        else if (index === 8 ||  index === 10) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              }
            }, 0);
          }
        } else {
          sums[index] = "";
        }
      });
      if(sums[10]){
        let val =  Math.floor(sums[10] * 100) / 100
        sums[10] = val
      }
        if(sums[8]){
        let val =  Math.floor(sums[8] * 100) / 100
        sums[8] = val
      }
      return sums;
    },
        ChangeOsData(val){
      let arr =[]
      for(let res of val){
        arr.push(res[1])
      }
      this.ChangeItem = arr
    },
        receiptChange(){
      let arr = []
      for(let val of this.receiptType){
        for(let res of this.ReceiptWayval){
           if(val.receiptTypevalue == res){
             arr.push(val.receiptTypelabel)
           }
        }
      }
      this.payMethods = arr
    },
             RECEIPT(){
        this.$http.get("/charge/web/chargeMethod/selectList").then((res) => {
          let date = res.data.data
          let arr = []
          for(let val of date){
            let obj = {
              "receiptTypevalue":val.id,
              "receiptTypelabel":val.methodName,
            }
            arr.push(obj)
          }
          this.receiptType = arr
        })
      },
    Derive(){

    },
    Create(){
        // 生成
        // console.log("生成报表")
        this.loading = true
        this.ShareList()
    },
      BillDateTime(time){
      var d = this.DateTime[0]
      	let year = d.getFullYear();
	    	let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1 ): d.getMonth() + 1
	    	let dates = d.getDate()< 10 ? '0' +d.getDate() : d.getDate()
       var ds = this.DateTime[1]
      	let years = ds.getFullYear();
	    	let months = ds.getMonth() + 1 < 10 ? '0' + (ds.getMonth() + 1 ): ds.getMonth() + 1
	    	let datess = ds.getDate()< 10 ? '0' +ds.getDate() : ds.getDate()
      this.fromDate =d.getTime()
      this.toDate = ds.getTime()
    },
     getMsgFormSon(data){
       let arr =[]
        if(data.chack == false){
for (var i = 0; i < this.CheckArr.length; i++) {
            if ((this.CheckArr[i].id).indexOf(data.object.id) > -1) {//判断key为999的对象是否存在，
               var index = i;
                this.CheckArr.splice(index, 1);//存在即删除
            }
        }
        }else{
          arr.push(data.id)
        }
        this.projectIds = arr
        this.ShareList()
    },
    ShareList(){
      let obj = {
"startSkrq": this.fromDate,
  "endSkrq": this.toDate,
  "projectIds": this.projectIds,
 "feeCodes": this.ChangeItem,
  "invoiceDm":this.Macode,
  "invoiceHm":this.Macodde,
  "payMethods":this.payMethods
      }
        this.$http.post(this.$requestUrl.POST_BILLINALID,obj).then((res) => {
          let data = res.data;
          if (200 === data.code) {
             this.total = data.total
             for(let val of data.data){
               val.SRu = val.inf.money - val.inf.tax
              if(val.zjSkrq != null){
                 val.zjSkrqDate = val.zjSkrq.replace("T"," ").substring(0,19)
              }
              if(val.scrapDate != null){
                 val.scrapDateS = val.scrapDate.replace("T"," ").substring(0,19)
              }
             }
              if(data.data == null  || data.data == [] || data.data == undefined){
          this.$message({
                message: '暂无数据',
                type: 'warning'
              });
              this.loading = false
        }else{
            this.tableData = data.data
        this.loading = false
        }

          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    NodeData(data){
        // console.log(data,"data")
        this.loading = true
        let arr =[]
        arr.push(data.id)
        this.projectIdT = arr
        this.mangroupId = data.value
        this.mangrouplab = data.label
          this.ShareList()
    },
        handleSizeChange(val) {
        this.pagesize  = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
              ChargeItem(){
        // 收费项目
        this.$http.get("/charge/web/chargeFeeitem/getAllFeeItem").then((res)=>{
          let data = res.data.data
          this.ItemTraverse = data
          this.ChargeItemTraverse(data)
        })
      },   ChargeItemTraverse(params){
        let result = []
        for(let val of params){
          if(val.feeCategory =="08"){
             var parent = {
                'label': "押金",
                "value":"08"
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="01"){
             var parent = {
                'label': "日常收费",
                'value':"01"
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="02"){
             var parent = {
                'label': "停车收费",
                'value':'02'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="03"){
             var parent = {
                'label': "装修收费",
                'value':'03'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="3"){
             var parent = {
                'label': "进户收费",
                'value':'3'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="04" || val.feeCategory =="05" ){
            if(val.feeCategory =="04"){
               var parent = {
                'label': "代收费",
                'value':'04'
              }
            }else{
              var parent = {
                'label': "代收费",
                'value':'05'
              }
            }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="06"){
             var parent = {
                'label': "其他",
                'value':'06'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="07"){
             var parent = {
                'label': "分等收费",
                'value':'07'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
          if(val.feeCategory =="09"){
             var parent = {
                'label': "西北收费",
                'value':'09'
              }
          parent.children = this.getchilds(val.feeCategory, params);//获取子节点
          }
        result.push(parent)
        }
        this.DeWeight(result)
        this.osData = result
      },
      getchilds(id,arr){
        let childs = new Array();
        for(let val of arr){
          if (val.feeCategory == id) {
            childs.push({
                'label': val.feeName,
                'value': val.feeCode,
                'type':val.feeCategory,
                'id':val.id
            });
          }
        }
        return childs;
      },
       DeWeight(arr){
          for(var i=0; i<arr.length; i++){
            for(var j=i+1; j<arr.length; j++){
                if(arr[i].label==arr[j].label){ 
                    arr.splice(j,1);
                    j--;
                }
            }
        }
      return arr;
      },
  },
  mounted() {
    this.RECEIPT()
    this.ChargeItem()
    	let date = new Date();
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let hh = new Date().getHours()
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes():new Date().getMinutes()
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds():new Date().getSeconds()
	    	let arr = ['星期天','星期一','星期二','星期三','星期四','星期五','星期六'];
	    	let day = date.getDay();
            let time = year+"-"+month+"-"+dates
            // console.log(time)
            this.fromDate = date.getTime()
            this.toDate = date.getTime()

  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
.el-cascader-node__label{
  color: black;
}
</style>